var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { isEmpty } from '../../util';
import { TextField } from '../TextField';
import { PasswordFieldMaskingToggle, ForgotPasswordLink } from './elements';
export var PasswordField = React.forwardRef(function (_a, fRef) {
    var _b = _a.showPassword, showPasswordOverride = _b === void 0 ? false : _b, _c = _a.showMaskingToggle, showMaskingToggle = _c === void 0 ? false : _c, forgotPasswordHref = _a.forgotPasswordHref, forgotPasswordLabel = _a.forgotPasswordLabel, _d = _a.affixRight, affixRight = _d === void 0 ? null : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.containerStyle, containerStyle = _f === void 0 ? {} : _f, restProps = __rest(_a, ["showPassword", "showMaskingToggle", "forgotPasswordHref", "forgotPasswordLabel", "affixRight", "disabled", "containerStyle"]);
    var _g = useState(showPasswordOverride), showPassword = _g[0], setShowPassword = _g[1];
    useEffect(function () {
        if (typeof showPasswordOverride != 'undefined') {
            setShowPassword(showPasswordOverride);
        }
    }, [showPasswordOverride]);
    var inputType = showPassword ? 'text' : 'password';
    var forgotPasswordHrefPresent = !isEmpty(forgotPasswordHref);
    return (React.createElement("div", { style: __assign({ display: 'flex', flexDirection: 'column', alignItems: 'end' }, containerStyle) },
        React.createElement(TextField, __assign({ ref: fRef, type: inputType, affixRight: showMaskingToggle ? (React.createElement(PasswordFieldMaskingToggle, { "data-testid": "password-field-masking-toggle", onClick: function (e) {
                    e.stopPropagation();
                    setShowPassword(!showPassword);
                } }, showPassword ? 'Hide' : 'Show')) : (affixRight), disabled: disabled, affixRightClickable: showMaskingToggle }, restProps)),
        forgotPasswordHrefPresent && (React.createElement(ForgotPasswordLink, { href: forgotPasswordHref, color: "secondary", disabled: disabled, className: disabled ? 'disabled' : '' }, forgotPasswordLabel !== null && forgotPasswordLabel !== void 0 ? forgotPasswordLabel : 'Forgot password?'))));
});
